module.exports = __webpack_public_path__ + "static/media/icon_tab_close_all.70748ca1.svg";